import React, {useMemo, useEffect} from 'react';
import {Container} from 'reactstrap';
import PopupHeadlineComponent from './PopupSharedComponents/PopupHeadlineComponent';
import PopupDescriptionComponent from './PopupSharedComponents/PopupDescriptionComponent';
import PopupImageComponent from './PopupSharedComponents/PopupImageComponent';
import CallBackComponent from './PopupSharedComponents/CallBackComponent';
import ThemedLottie from '../../../Shared/ThemedLottie/ThemedLottie';
import PaperPlane from '../../../../animations/paperPlane.json';
import { ThemeColorEnum } from '../../../../utilities/theme/ThemeColorEnum';
const BasicErrorPopup = (props) => {
  return (
    <Container>
      <PopupHeadlineComponent title={props.popupData.headline} />
      {props.popupData.id != 'defaultPackageExists' && (
        <>
          {props.popupData.animated ? (
            <ThemedLottie animationData={PaperPlane} color={ThemeColorEnum.PRIMARY} loop={false} width={250} />
          ) : (
            <PopupImageComponent icon={props.popupData.icon} animated={props.popupData.animated} />
          )}
        </>
      )}
      {props.popupData.description && <PopupDescriptionComponent boldDescription={props.popupData.description} />}
      {props.popupData.descriptionBold && <PopupDescriptionComponent boldDescription={props.popupData.descriptionBold} />}

      <CallBackComponent isBusiness={props.isBusiness} onclick={props.onclick} />
    </Container>
  );
};
export default BasicErrorPopup;
